module.exports = __webpack_public_path__ + "static/media/reward.12005b44.png";